// «Сделать варианты» победившего ролика: батч агенту штатным путём (бюджет батча). Ядро ролика — механику
// товара, голос, оффер и цену — агент сохраняет, хук, первый кадр, музыку, призыв и длину освежает сам.
import { Button, Segmented, toast } from '@autoaff/ui';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { type FormEvent, useState } from 'react';
import { api } from '../../api';
import { SidePanel } from '../../shell/SidePanel';

const COUNTS = ['2', '3', '4', '5', '6'] as const;
type Count = (typeof COUNTS)[number];

export function VariantsPanel({
  open,
  onClose,
  creative,
}: {
  open: boolean;
  onClose: () => void;
  creative: { id: number; code: string; fatigue?: { summary: string } | null };
}) {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const [count, setCount] = useState<Count>('3');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api<{ id: number; threadId: string }>(`/api/creatives/${creative.id}/variants`, {
        count: Number(count),
        ...(note.trim() ? { note: note.trim() } : {}),
      });
      await qc.invalidateQueries({ queryKey: ['creatives'] });
      toast('Варианты в очереди агента — ход работы виден в треде');
      onClose();
      void navigate({ to: '/agent/chats/$threadId', params: { threadId: r.threadId } });
    } catch (err) {
      toast((err as Error).message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <SidePanel
      open={open}
      label="Варианты ролика"
      onClose={onClose}
      head={<div className="sp-title">Варианты ролика {creative.code}</div>}
    >
      <form className="form-stack" onSubmit={submit}>
        <p className="muted">
          Агент сохранит главное — как товар работает в кадре, голос, оффер и цену — и освежит то, что
          приедается: хук первых 2 секунд, первый кадр, музыку, призыв, длину. Что именно менять, решит сам по
          цифрам ролика. Почти без новых генераций, бюджет — как у батча.
        </p>
        {creative.fatigue && <p className="variants-why">Ролик выгорает: {creative.fatigue.summary}.</p>}
        <span className="label">Сколько вариантов</span>
        <Segmented
          label="Сколько вариантов"
          value={count}
          onChange={setCount}
          options={COUNTS.map((n) => ({ value: n, label: n }))}
        />
        <label className="label" htmlFor="var-note">
          Пожелания (необязательно)
        </label>
        <textarea
          id="var-note"
          className="input textarea"
          rows={3}
          maxLength={2000}
          placeholder="Например: хук вопросом, один вариант короче на 5 секунд"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        <Button type="submit" variant="primary" block disabled={busy}>
          Запустить варианты
        </Button>
      </form>
    </SidePanel>
  );
}
